export default "<div class=\"mt-2\">\r\n    <app-returned-list></app-returned-list>\r\n</div>"